export default __webpack_public_path__ + "static/media/voucherGTS5.1cfd1072.jpg";